import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { appActions } from "./actions";
import { AppState } from "./types";

const initialState: AppState = {
    isLoading: false,
    showModal: false,
    modalObject: null,
};

export function AppReducer(state = initialState, action: Action): AppState {
    if (isType(action, appActions.showLoading)){
        return {
            ...state,
            isLoading: true,
        };
    }

    if (isType(action, appActions.hideLoading)) {
        return {
            ...state,
            isLoading: false,
        }
    };

    if (isType(action, appActions.showModal.done)) {
        return {
            ...state,
            showModal: true,
            modalObject: null,
        }
    };

    if (isType(action, appActions.closeModal)) {
        return {
            ...state,
            showModal: false,
            modalObject: null,
        }
    };

    if (isType(action, appActions.resetToInitialState)) {
        return initialState;
    }

    return state;
}